module.exports = new __parcel__URL__("firecrystal.6d2fabef.png").toString();